export default {
	update(form, cb, ecb) {
		this.http
			.post('/category', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb) {
		this.http.get(`/category/${id}`, {}).then((r) => {
			cb(r)
		})
	},
	getByIds(ids, cb) {
		this.http.get(`/category/${ids}`, {}).then((r) => {
			cb(r)
		})
	},
	remove(id, cb, ecb) {
		this.http
			.delete(`/category/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},

	getMetas(id, cb) {
		this.http.get(`/category/getMetas/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	getTree(id, cb, ecb) {
		this.http
			.get(`/category/tree/${id}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getShopTree(shopid, cb, ecb) {
		this.http
			.get(`/category/getShopTree/${shopid}`, {})
			.then((response) => {
				cb(response)
			})
			.catch((e) => ecb && ecb(e))
	},
	getChildren(id, params, cb, ecb) {
		this.http
			.get(`/category/getChildren/${id}`, {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getTags(id, cb, ecb) {
		this.http
			.get(`/category/getTags/${id}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
